<script>
export default {
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            default: '',
        },
    },
};
</script>

<template>
    <div v-html="field.data_value" />
</template>

<style
    scoped
    lang="scss"
>

</style>
